import React, { useContext, useEffect, useState } from "react";

const InformacionAcreditados = ({ acreditadoInfo, titulo, description }) => {
  return (
    <h1 className="ConvenioItem">
      {titulo}: <span>{description}</span>
    </h1>
  );
};

export default InformacionAcreditados;
